import axios from 'axios';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import DefaultLoader from '../loader/DefaultLoader';
import {useCookies} from 'react-cookie';
import PlayerSlide from '../slide/PlayerSlide';
import dateSetting from '../../utils/dateSetting';
import { useTranslation } from 'react-i18next';

function SeriesPitcherList({teamObj, title, pitcherType, checked, profile}) {
    const [cookies] = useCookies(['hiball_token']);
    let [pitcherArr, setPitcherArr] = useState([]);
    const { t } = useTranslation();

    useEffect(() => {
        let dateObj = dateSetting();
        let params = {
            recordType: 'digestPitchingRecord', recordName: 'selectMaxIpPlayer',
            pitcherTeamIds: teamObj['teamId'],
            seasons: [dateObj['season'], dateObj['season']-1].toString(),
            pitcherTypeCode: pitcherType,
            gameTypeCode: 4201,
            authToken:JSON.stringify(cookies['hiball_token'])
        }

        if(checked) {
            params['batterIds'] = profile['playerId'];
        }

        axios({
            url : `${process.env.REACT_APP_API_URL}`, params    
        }).then((result) => {
            let matchPitcher = result['data']['result'];
            let sortPitcher = _.sortBy(matchPitcher, (item) => {
                return item['total_out_count'];
            }).reverse();

            setPitcherArr(sortPitcher);
        });
    }, [teamObj, checked]);

    if(teamObj['teamId'] === 0 || pitcherArr.length === 0) {
        return (
            <>
                <div className={(pitcherType === 5102) ? 'starter' : 'relief'}>
                <div className="listTitle">
                    <hr/>{t(title)}<hr/>
                </div>
                <div className="imageWrap" style={{height:'126px', justifyContent: 'center'}}>
                    <div>No Data</div>
                </div>
                </div>
            </>
        )
    }

    return (
        <>
            <div className={(pitcherType === 5102) ? 'starter' : 'relief'}>
                <div className="listTitle">
                    <hr/>{t(title)}<hr/>
                </div>
                <PlayerSlide data={pitcherArr} position={"pitcher"} checked={checked} profile={profile}/>
            </div>
        </>
    )
}

export default SeriesPitcherList;